// Loading states for CopilotBar component
export const COPILOT_BAR_LOADING_STATES = {
    IDLE: 'idle',
    LOADING: 'loading',
    COMPLETED: 'completed',
    RECORDING_ERROR: 'recording_error',
    PROCESSING_ERROR: 'processing_error',
};

/** Where CopilotBar routes streamed answer text (opt-in via chatSetup.answerDisplay). */
export const COPILOT_BAR_ANSWER_DISPLAY_MODES = {
    LOADING: 'loading',
    FEEDBACK: 'feedback',
};

/** Which source wins for loadingPhrase when both stream and form progress update it. */
export const COPILOT_BAR_LOADING_PHRASE_PRIORITY = {
    STREAM_TEXT: 'streamText',
    FORM_PROGRESS: 'formProgress',
};

// Regex patterns - Optimized for performance
export const CHART_REGEX = /\[fm_report=(['"])([^'"]*)\1\]/;
export const CHART_REGEX_GLOBAL = /\[fm_report=(['"])([^'"]*)\1\]/g;
export const DETAIL_REGEX = /\[fm_detail=(['"])([^'"]*)\1\]/;
export const DETAIL_REGEX_GLOBAL = /\[fm_detail=(['"])([^'"]*)\1\]/g;
export const TABLE_REGEX = /\[fm_table=(['"])([^'"]*)\1\]/;
export const TABLE_REGEX_GLOBAL = /\[fm_table=(['"])([^'"]*)\1\]/g;
export const MARKDOWN_BOLD_REGEX = /\*\*([^*]+)\*\*/g;

// SVG Icons
export const SVG_DOWNLOAD = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#7D8A96" fill-rule="evenodd" d="M19 9h-4V3H9v6H5l7 7 7-7ZM5 18v2h14v-2H5Z" clip-rule="evenodd"/></svg>`;

// Stream identifiers
export const COPILOT_CHAT_STREAM_IDENTIFIERS = {
    detail: 'data-fm_detail',
    chart: 'data-fm_action_chart',
    table: 'data-fm_action_table',
    detailShort: 'fm_detail',
    chartShort: 'fm_action_chart',
    tableShort: 'fm_action_table',
};

// Chart defaults
export const CHART_DEFAULTS = {
    width: 533,
    height: 300,
    devicePixelRatio: 2.5,
    padding: 12,
    colorThreshold: 170,
    grayscaleWeights: [0.299, 0.587, 0.114],
};

// Input modes for CopilotBar
export const INPUT_MODE = {
    FILE: 'file',
    TEXT: 'text',
    URL: 'url',
};

export const INPUT_MODE_CONFIG = {
    [INPUT_MODE.TEXT]: {
        placeholderKey: 'placeholder_copilot_bar_crud',
    },
    [INPUT_MODE.FILE]: {
        icon: 'attachFileVertical',
        hasDividerAfter: true,
        placeholderKey: 'label_copilot_voicecrud_describe_information_to_extract_from_file',
        titleKey: 'label_copilot_voicecrud_fill_from_a_file',
    },
    [INPUT_MODE.URL]: {
        icon: 'world',
        placeholderKey: 'label_copilot_voicecrud_add_the_url_you_want_extract_information_from',
        showChipInBottomComponent: true,
        titleKey: 'label_copilot_voicecrud_fill_from_a_url',
    },
};

export const INPUT_MODE_SELECTOR_OPTIONS = [INPUT_MODE.FILE, INPUT_MODE.URL];

// Feedback types for CopilotBar inline feedback
const FEEDBACK_TYPES = {
    ERROR: 'error',
    HINT: 'hint',
    INFO: 'info',
    INTERACTIVE: 'interactive',
    WARNING: 'warning',
};

export const DEFAULT_INPUT_MODE = INPUT_MODE.TEXT;

/** Maximum cumulative size (bytes) for CopilotBar file attachments. */
export const COPILOT_BAR_MAX_ATTACHMENTS_TOTAL_SIZE = 5 * 1024 * 1024;

/** Accepted MIME types for CopilotBar file attachments. */
export const COPILOT_BAR_ALLOWED_ATTACHMENT_TYPES = [
    'application/pdf',
    'image/bmp',
    'image/gif',
    'image/heic',
    'image/heif',
    'image/jpeg',
    'image/png',
    'image/webp',
];

// Placeholder keys for each input mode
export const INPUT_MODE_PLACEHOLDER_KEYS = {
    [INPUT_MODE.TEXT]: INPUT_MODE_CONFIG[INPUT_MODE.TEXT].placeholderKey,
    [INPUT_MODE.FILE]: INPUT_MODE_CONFIG[INPUT_MODE.FILE].placeholderKey,
    [INPUT_MODE.URL]: INPUT_MODE_CONFIG[INPUT_MODE.URL].placeholderKey,
};
